<template>
    <section id="mainContainer">
        <adminHeader></adminHeader>
        <section class="admin-mid-container">
            <div class="admin-custom-row admin-page-row" id="leftMenuSlideBox">
                <adminNavigation></adminNavigation>
                <section class="admin-right-sidebar">
                    <div class="admin-right-sidebar-in">
                        <div class="admin-right-sidebar-in-top">
                            <div class="admin-custom-row">
                                <div class="admin-right-sidebar-in-top-left">
                                    <h1>
                                        {{ constants.DASHBOARD_TEXT }}
                                    </h1>

                                </div>
                            </div>
                        </div>
                        <div class="dashboard-page">
                            <div class="admin-custom-row">
                                <div class="item-4 dashboard-item-col">
                                    <div class="banners-bg radius-10 admin-padding-15">
                                        <div class="dashboard-item-col-top">
                                            <div class="dashboard-item-col-top-left">
                                                <span>
                                                    {{ constants.TOTAL_TEXT }}</span> <i>{{ bannerCounts.all }}</i>
                                            </div>
                                            <div class="dashboard-item-col-top-right">
                                                <span>{{ constants.UNPUBLISHED_TEXT }}: </span>
                                                <i>{{ bannerCounts.unpublished }}</i>
                                            </div>
                                        </div>
                                        <div class="dashboard-item-col-mid">
                                            <div class="dashboard-item-col-mid-left">
                                                <strong>{{ bannerCounts.published }}</strong>
                                                <span>{{ constants.PUBLISHED_BANNERS_TEXT }}</span>
                                            </div>
                                            <div class="dashboard-item-col-mid-right">
                                                <div class="dashboard-item-col-icon">
                                                    <img src="@/assets/images/admin-img/dashboard-banners-icon.svg"
                                                        alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="dashboard-item-col-btm">
                                            <div class="btn-set-left-align">
                                                <router-link to="/authority/Banners" id="bannerDetailsLink"
                                                    class="link-blue-arrow">{{ constants.DETAILS_LINK }}</router-link>
                                                <!-- <a href="banner-images.html" id="bannerDetailsLink" class="link-blue-arrow">{{constants.DETAILS_LINK}}</a> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item-4 dashboard-item-col">
                                    <div class="articles-bg radius-10 admin-padding-15">
                                        <div class="dashboard-item-col-top">
                                            <div class="dashboard-item-col-top-left">
                                                <span>{{ constants.TOTAL_TEXT }}</span> <i>{{ articleCounts.all }}</i>
                                            </div>
                                            <div class="dashboard-item-col-top-right">
                                                <span>{{ constants.UNPUBLISHED_TEXT }}: </span>
                                                <i>{{ articleCounts.unpublished }}</i>
                                            </div>
                                        </div>
                                        <div class="dashboard-item-col-mid">
                                            <div class="dashboard-item-col-mid-left">
                                                <strong>{{ articleCounts.published }}</strong>
                                                <span>{{ constants.PUBLISHED_ARTICLES_TEXT }}</span>
                                            </div>
                                            <div class="dashboard-item-col-mid-right">
                                                <div class="dashboard-item-col-icon">
                                                    <img src="@/assets/images/admin-img/dashboard-articles-icon.svg"
                                                        alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="dashboard-item-col-btm">
                                            <div class="btn-set-left-align">
                                                <router-link to="/authority/articles" id="articlesDetailsLink"
                                                    class="link-blue-arrow">{{ constants.DETAILS_LINK }}</router-link>
                                                <!-- <a href="articles.html" id="articlesDetailsLink" class="link-blue-arrow">{{constants.DETAILS_LINK}}</a> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item-4 dashboard-item-col">
                                    <div class="services-bg radius-10 admin-padding-15">
                                        <div class="dashboard-item-col-top">
                                            <div class="dashboard-item-col-top-left">
                                                <span>{{ constants.TOTAL_TEXT }}</span> <i>{{ serviceCounts.all }}</i>
                                            </div>
                                            <div class="dashboard-item-col-top-right">
                                                <span>{{ constants.UNPUBLISHED_TEXT }}: </span>
                                                <i>{{ serviceCounts.unpublished }}</i>
                                            </div>
                                        </div>
                                        <div class="dashboard-item-col-mid">
                                            <div class="dashboard-item-col-mid-left">
                                                <strong>{{ serviceCounts.published }}</strong>
                                                <span>{{ constants.PUBLISHED_SERVICES_TEXT }}</span>
                                            </div>
                                            <div class="dashboard-item-col-mid-right">
                                                <div class="dashboard-item-col-icon">
                                                    <img src="@/assets/images/admin-img/dashboard-services-icon.svg"
                                                        alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="dashboard-item-col-btm">
                                            <div class="btn-set-left-align">
                                                <router-link to="/authority/services" id="servicesDetailsLink"
                                                    class="link-blue-arrow">{{ constants.DETAILS_LINK }}</router-link>
                                                <!-- <a href="services.html" id="servicesDetailsLink" class="link-blue-arrow">{{constants.DETAILS_LINK}}</a> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="item-5 dashboard-item-col dashboard-item-col-sm">
                                    <div class="industry-bg radius-10 admin-padding-15">
                                        <div class="dashboard-item-col-top">
                                            <div class="dashboard-item-col-top-left">
                                                <span>{{ constants.TOTAL_TEXT }}</span> <i>{{ industryCounts.all }}</i>
                                            </div>
                                            <div class="dashboard-item-col-top-right">
                                                <span>{{ constants.UNPUBLISHED_TEXT }}</span> <i>{{
                                                    industryCounts.unpublished }}</i>
                                            </div>
                                        </div>
                                        <div class="dashboard-item-col-mid">
                                            <div class="dashboard-item-col-mid-left">
                                                <strong>{{ industryCounts.published }}</strong>
                                                <span>{{ constants.PUBLISHED_INDUSTRY_TEXT }}</span>
                                            </div>
                                            <div class="dashboard-item-col-mid-right">
                                                <div class="dashboard-item-col-icon">
                                                    <img src="@/assets/images/admin-img/dashboard-industry-icon.svg"
                                                        alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="dashboard-item-col-btm">
                                            <div class="btn-set-left-align">
                                                <router-link to="/authority/industry" id="industryDetailsLink"
                                                    class="link-blue-arrow">{{ constants.DETAILS_LINK }}</router-link>
                                                <!-- <a href="industry.html" id="industryDetailsLink" class="link-blue-arrow">{{constants.DETAILS_LINK}}</a> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item-5 dashboard-item-col dashboard-item-col-sm">
                                    <div class="clients-bg radius-10 admin-padding-15">
                                        <div class="dashboard-item-col-top">
                                            <div class="dashboard-item-col-top-left">
                                                <span>{{ constants.TOTAL_TEXT }}</span> <i>{{ clientCounts.all }}</i>
                                            </div>
                                            <div class="dashboard-item-col-top-right">
                                                <span>{{ constants.UNPUBLISHED_TEXT }}</span>
                                                <i>{{ clientCounts.unpublished }}</i>
                                            </div>
                                        </div>
                                        <div class="dashboard-item-col-mid">
                                            <div class="dashboard-item-col-mid-left">
                                                <strong>{{ clientCounts.published }}</strong>
                                                <span>{{ constants.PUBLISHED_CLIENTS_TEXT }}</span>
                                            </div>
                                            <div class="dashboard-item-col-mid-right">
                                                <div class="dashboard-item-col-icon">
                                                    <img src="@/assets/images/admin-img/dashboard-clients-icon.svg"
                                                        alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="dashboard-item-col-btm">
                                            <div class="btn-set-left-align">
                                                <router-link to="/authority/clients" id="industryDetailsLink"
                                                    class="link-blue-arrow">{{ constants.DETAILS_LINK }}</router-link>
                                                <!-- <a href="clients.html" id="clientsDetailsLink" class="link-blue-arrow">{{constants.DETAILS_LINK}}</a> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item-5 dashboard-item-col dashboard-item-col-sm">
                                    <div class="jobs-bg radius-10 admin-padding-15">
                                        <div class="dashboard-item-col-top">
                                            <div class="dashboard-item-col-top-left">
                                                <span>{{ constants.TOTAL_TEXT }}</span> <i>{{ jobCounts.all }}</i>
                                            </div>
                                            <div class="dashboard-item-col-top-right">
                                                <span>{{ constants.UNPUBLISHED_TEXT }}</span>
                                                <i>{{ jobCounts.unpublished }}</i>
                                            </div>
                                        </div>
                                        <div class="dashboard-item-col-mid">
                                            <div class="dashboard-item-col-mid-left">
                                                <strong>{{ jobCounts.published }}</strong>
                                                <span>{{ constants.PUBLISHED_JOBS_TEXT }}</span>
                                            </div>
                                            <div class="dashboard-item-col-mid-right">
                                                <div class="dashboard-item-col-icon">
                                                    <img src="@/assets/images/admin-img/dashboard-jobs-icon.svg"
                                                        alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="dashboard-item-col-btm">
                                            <div class="btn-set-left-align">
                                                <router-link to="/authority/manage-job" id="jobsDetailslink"
                                                    class="link-blue-arrow">{{ constants.DETAILS_LINK }}</router-link>
                                                <!-- <a href="manage-jobs.html" id="jobsDetailslink" class="link-blue-arrow">{{constants.DETAILS_LINK}}</a> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item-5 dashboard-item-col dashboard-item-col-sm">
                                    <div class="blogs-bg radius-10 admin-padding-15">
                                        <div class="dashboard-item-col-top">
                                            <div class="dashboard-item-col-top-left">
                                                <span>{{ constants.TOTAL_TEXT }}</span> <i>{{ blogCounts.all }}</i>
                                            </div>
                                            <div class="dashboard-item-col-top-right">
                                                <span>{{ constants.UNPUBLISHED_TEXT }}</span>
                                                <i>{{ blogCounts.unpublished }}</i>
                                            </div>
                                        </div>
                                        <div class="dashboard-item-col-mid">
                                            <div class="dashboard-item-col-mid-left">
                                                <strong>{{ blogCounts.published }}</strong>
                                                <span>{{ constants.PUBLISHED_BLOGS_TEXT }}</span>
                                            </div>
                                            <div class="dashboard-item-col-mid-right">
                                                <div class="dashboard-item-col-icon">
                                                    <img src="@/assets/images/admin-img/dashboard-blogs-icon.svg"
                                                        alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="dashboard-item-col-btm">
                                            <div class="btn-set-left-align">
                                                <router-link to="/authority/manage-blog" id="blogDetailsLink"
                                                    class="link-blue-arrow">{{ constants.DETAILS_LINK }}</router-link>
                                                <!-- <a href="manage-blog.html" id="blogDetailsLink" class="link-blue-arrow">{{constants.DETAILS_LINK}}</a> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item-5 dashboard-item-col dashboard-item-col-sm">
                                    <div class="contact-us-bg radius-10 admin-padding-15">
                                        <div class="dashboard-item-col-top" style="opacity: 0;">
                                                <div class="dashboard-item-col-top-left">
                                                    <span>{{constants.TOTAL_TEXT}}</span> <i>55</i>
                                                </div>
                                                <div class="dashboard-item-col-top-right">
                                                    <span>{{constants.UNPUBLISHED_TEXT}}</span> <i>30</i>
                                                </div>
                                             </div>
                                        <div class="dashboard-item-col-mid">
                                            <div class="dashboard-item-col-mid-left">
                                                <strong>{{ contactCounts }}</strong>

                                                <span>{{ constants.CONTACT_US_MENU }}</span>
                                            </div>
                                            <div class="dashboard-item-col-mid-right">
                                                <div class="dashboard-item-col-icon">
                                                    <img src="@/assets/images/admin-img/dashboard-contact-us-icon.svg"
                                                        alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="dashboard-item-col-btm">
                                            <div class="btn-set-left-align">
                                                <router-link to="/authority/contactUs" id="contactDetailsLink"
                                                    class="link-blue-arrow">{{ constants.DETAILS_LINK }}</router-link>
                                                <!-- <a href="contact.html" id="contactDetailsLink" class="link-blue-arrow">{{constants.DETAILS_LINK}}</a> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="item-2 dashboard-item">
                                    <div class="radius-10 admin-padding-15 dashboard-team-box">
                                        <div class="dashboard-item-top">
                                            <h3>{{ constants.TEAMS_TEXT }}</h3>
                                            <div class="dashboard-tabs">
                                                <ul>
                                                    <li>
                                                        <a id="publishedLink"
                                                            :class="{ active: teamMemberActiveTab === 1 }" href="#"
                                                            @click.prevent="setActiveTab(1)">PUBLISHED:
                                                            {{ teamMemberCounts.published }}</a>
                                                    </li>
                                                    <li>
                                                        <a id="unPublishedLink"
                                                            :class="{ active: teamMemberActiveTab === 0 }" href="#"
                                                            @click.prevent="setActiveTab(0)">UNPUBLISHED:
                                                            {{ teamMemberCounts.unpublished }}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="dashboard-item-btm">
                                            <div class="dashboard-team-row published-team"
                                                v-show="teamMemberActiveTab === 1">
                                                <div class="dashboard-team-col" v-for="member in teamMembers"
                                                    :key="member.id">
                                                    <div class="dashboard-team-box">
                                                        <div class="dashboard-team-box-img">
                                                            <img :src="getCdnImageAddress(member.teamMemberImage, `w_60,h_60/`)" alt="member.name">
                                                        </div>
                                                        <div class="dashboard-team-box-name">
                                                            <h4>{{ member.name }}</h4>
                                                            <span>{{ member.designation }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="teamMemberActiveTab === 1 && teamMembers.length === 0">
                                                No Data To Display
                                            </div>
                                            <div class="dashboard-team-row unpublished-team" style="display: none;"
                                                v-show="teamMemberActiveTab === 0">
                                                <div class="dashboard-team-col" v-for="member in teamMembers"
                                                    :key="member.id">
                                                    <div class="dashboard-team-box">
                                                        <div class="dashboard-team-box-img">
                                                            <img :src="getCdnImageAddress(member.teamMemberImage, `w_60,h_60/`)" alt="member.name">
                                                        </div>
                                                        <div class="dashboard-team-box-name">
                                                            <h4>{{ member.name }}</h4>
                                                            <span>{{ member.designation }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="teamMemberActiveTab === 0 && teamMembers.length === 0">
                                                No Data To Display
                                            </div>

                                        </div>
                                        <div class="btn-set-left-align">
                                            <router-link to="/authority/manage-team" id="jobsDetailslink"
                                                class="link-blue-arrow">{{ constants.DETAILS_LINK }}</router-link>
                                            <!-- <a href="manage-team.html" id="jobsDetailslink" class="link-blue-arrow">{{constants.DETAILS_LINK}}></a> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="item-2 dashboard-item">
                                    <div class="radius-10 admin-padding-15 dashboard-join-team-box">
                                        <div class="dashboard-item-top">
                                            <h3>{{ constants.JOIN_OUR_TEAM_TEXT }} ({{joinOurTeamCounts}})</h3>
                                        </div>
                                        <div class="dashboard-item-btm">
                                            <div class="dashboard-join-team-row">
                                                <div class="dashboard-join-team-col dashboard-join-team-hd">
                                                    <div class="dashboard-join-team-img">{{ constants.IMAGE_LABEL }}
                                                    </div>
                                                    <div class="dashboard-join-team-name"> {{ constants.NAME_LABEL }}
                                                    </div>
                                                    <div class="dashboard-join-team-designation">
                                                        {{ constants.DESIGNATION_LABEL }}</div>
                                                    <div class="dashboard-join-team-action">{{ constants.ACTION_LABEL }}
                                                    </div>
                                                </div>
                                                <div class="dashboard-join-team-list">
                                                    <div class="dashboard-join-team-col"
                                                        v-for="(member, index) in joinOurTeam" :key="index">
                                                        <div class="dashboard-join-team-img">
                                                            <img :src="getCdnImageAddress(member.candidateImage, `w_60,h_60/`)"
                                                                alt="member.candidateName" />
                                                        </div>
                                                        <div class="dashboard-join-team-name">{{ member.candidateName }}
                                                        </div>
                                                        <div class="dashboard-join-team-designation">{{
                                                            member.designation }}
                                                        </div>
                                                        <div class="dashboard-join-team-action">
                                                            <button class="dashboard-join-team-download-btn"
                                                                id="cvDeonloadBtn"
                                                                @click="downloadResume(member.id, member.candidateName)">
                                                                <i><img src="@/assets/images/admin-img/gray-pdf-icon.svg"
                                                                        alt="" /></i>
                                                                {{ constants.DOWNLOAD_BUTTON }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="joinOurTeam.length === 0">
                                                No Data To Display
                                            </div>
                                            <div class="btn-set-left-align">
                                                <router-link to="/authority/join-team" id="jobsDetailslink"
                                                    class="link-blue-arrow">{{ constants.DETAILS_LINK }}</router-link>
                                                <!-- <a href="join-our-team.html" id="jobsDetailslink"
                                                    class="link-blue-arrow">{{ constants.DETAILS_LINK }}</a> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="item-2 dashboard-item">
                                    <div class="radius-10 admin-padding-15 dashboard-job-category-box">
                                        <div class="dashboard-item-top">
                                            <h3>{{ constants.JOB_CATEGORY_TEXT }} ({{jobCategoryCounts}})</h3>
                                        </div>
                                        <div class="dashboard-item-btm">
                                            <div class="dashboard-job-category-row">
                                                <div class="dashboard-job-category-col dashboard-job-category-hd">
                                                    <div class="dashboard-job-category-title">
                                                        {{ constants.TITLE_LABEL }}
                                                    </div>
                                                    <div class="dashboard-job-category-active-inactive">
                                                        {{ constants.ACTIVE_INACTIVE_LABEL }}
                                                    </div>
                                                    <div class="dashboard-job-category-action">
                                                        {{ constants.ACTIONS_LABEL }}
                                                    </div>
                                                </div>
                                                <div class="dashboard-job-category-list">
                                                    <div class="dashboard-job-category-col" v-for="(member, index) in jobCategories" :key="member.id">
                                                        <div class="dashboard-job-category-title">
                                                            {{member.title}}
                                                        </div>
                                                        <div class="dashboard-job-category-active-inactive">
                                                            <div class="active-inactive-radio" @click="toggleStatus(member.id, member.status, 'job-category')">
                                                                <input id="ActiveInput" type="radio" :name="'job_status_' + member.id"
                                                                    class="active-radio" v-model="member.status"
                                                                    :value="1" />
                                                                <input id="InactiveInput" type="radio" :name="'job_status_' + member.id"
                                                                    class="inactive-radio" v-model="member.status"
                                                                    :value="0" /> 
                                                                <div class="active-inactive-radio-img"></div>
                                                            </div>
                                                        </div>
                                                        <div class="dashboard-job-category-action">
                                                            <ul class="admin-action-link">
                                                                <li>
                                                                    <button id="dashPgEditBtn" class="editBtn"  @click="goToEditPage(member.id, index)">
                                                                        {{ constants.EDIT_BUTTON }}
                                                                    </button>
                                                                </li>
                                                                <li>
                                                                    <button id="dashPgDeleteBtn" data-bs-toggle="modal"
                                                                        data-bs-target="#deletePop" @click="setDeleteMode( member.id)">
                                                                        {{ constants.DELETE_BUTTON }}
                                                                    </button>
                                                                </li>

                                                            </ul>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                            <div class="btn-set-left-align">
                                                <router-link to="/authority/job-category" id="jobsDetailslink"
                                                    class="link-blue-arrow">{{ constants.DETAILS_LINK }}</router-link>
                                                <!-- <a href="job-category.html" id="jobsDetailslink"
                                                    class="link-blue-arrow">{{ constants.DETAILS_LINK }}</a> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item-2 dashboard-item">
                                    <div class="radius-10 admin-padding-15 dashboard-blog-category-box">
                                        <div class="dashboard-item-top">
                                            <h3>{{ constants.BLOG_CATEGORY_TEXT }} ({{blogCategoryCounts}})</h3>
                                        </div>
                                        <div class="dashboard-item-btm">
                                            <div class="dashboard-job-category-row">
                                                <div class="dashboard-blog-category-col dashboard-blog-category-hd">
                                                    <div class="dashboard-blog-category-title">
                                                        {{ constants.TITLE_LABEL }}
                                                    </div>
                                                    <div class="dashboard-blog-category-active-inactive">
                                                        {{ constants.ACTIVE_INACTIVE_LABEL }}
                                                    </div>
                                                    <div class="dashboard-blog-category-action">
                                                        {{ constants.ACTIONS_LABEL }}
                                                    </div>
                                                </div>
                                                <div class="dashboard-blog-category-list">
                                                    <div class="dashboard-blog-category-col" v-for="(blog, index) in blogCategories" :key="blog.id">
                                                        <div class="dashboard-blog-category-title">
                                                            {{blog.title}}
                                                        </div>
                                                        <div class="dashboard-blog-category-active-inactive">
                                                            <div class="active-inactive-radio" @click="toggleStatus(blog.id, blog.status,'blog-category')">
                                                                <input id="ActiveInput" type="radio" :name="'blog_status_' + blog.id"
                                                                    class="active-radio" v-model="blog.status"
                                                                    :value="1" />
                                                                <input id="InactiveInput" type="radio"
                                                                :name="'blog_status_' + blog.id" class="inactive-radio"
                                                                v-model="blog.status"
                                                                :value="0" />
                                                                <div class="active-inactive-radio-img"></div>
                                                            </div>
                                                        </div>
                                                        <div class="dashboard-blog-category-action">
                                                            <ul class="admin-action-link">
                                                                <li>
                                                                    <button id="dashPgEditBtn" class="editBtn" @click="goToBlogEditPage(blog.id, index)">
                                                                        {{ constants.EDIT_BUTTON }}
                                                                    </button>
                                                                </li>
                                                                <li>
                                                                    <button id="dashPgDeleteBtn" data-bs-toggle="modal"
                                                                        data-bs-target="#deletePop" @click="setBlogDeleteMode( blog.id)">
                                                                        {{ constants.DELETE_BUTTON }}
                                                                    </button>
                                                                </li>

                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="btn-set-left-align">
                                                <router-link to="/authority/blog-category" id="jobsDetailslink"
                                                class="link-blue-arrow">{{ constants.DETAILS_LINK }}</router-link>
                                                <!-- <a href="blog-category.html" id="jobsDetailslink"
                                                    class="link-blue-arrow">{{ constants.DETAILS_LINK }}</a> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </section>
            </div>
        </section>
        <footer class="admin-site-footer">
            <div class="container">
                {{ constants.COPYRIGHT_TEXT }}
            </div>
        </footer>
        <div class="modal fade confirmation-popup" id="deletePop" tabindex="-1" role="dialog"
            aria-labelledby="deleteModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="confirmation-popup-icon">
                        <i><img src="@/assets/images/admin-img/light_delete-outline.svg" alt="" /></i>
                    </div>
                    <div class="confirmation-popup-mid">
                        {{ constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT }}
                    </div>
                    <div class="confirmation-popup-btm">
                        <button id="popNoBtn" class="admin-btn-outline-secondary" data-bs-dismiss="modal" @click="jobCategorieToDelete=null,blogCategorieToDelete=null">
                            {{ constants.NO_BUTTON }}
                        </button>
                        <button id="popYesBtn" class="admin-btn-outline-primary" data-bs-dismiss="modal" @click="deleteCategorie()">
                            {{ constants.YES_BUTTON }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import constants from "@/utils/en-US-Admin.json";
import adminHeader from "@/components/adminHeader.vue";
import adminNavigation from "@/components/adminNavigation.vue";
import axios from 'axios';
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import Swal from 'sweetalert2';
import { environment } from '@/config/environment';
import { API_BASE_URL } from '@/config/api.config';


export default defineComponent({
    name: "Dashboard",
    data() {
        return {
            constants,
            bannerCounts: {
                all: 0,
                published: 0,
                unpublished: 0,
            } as any,
            articleCounts: {
                all: 0,
                published: 0,
                unpublished: 0,
            } as any,
            serviceCounts: {
                all: 0,
                published: 0,
                unpublished: 0,
            } as any,
            industryCounts: {
                all: 0,
                published: 0,
                unpublished: 0
            } as any,
            clientCounts: {
                all: 0,
                published: 0,
                unpublished: 0
            } as any,
            jobCounts: {
                all: 0,
                published: 0,
                unpublished: 0
            } as any,
            blogCounts: {
                all: 0,
                published: 0,
                unpublished: 0
            } as any,
            contactCounts: 0,
            teamMemberCounts: {
                all: 0,
                published: 0,
                unpublished: 0
            } as any,
            teamMembers: [] as any,
            teamMemberActiveTab: 1,
            joinOurTeam: [] as any,
            joinOurTeamCounts: 0,
            jobCategoryCounts: 0,
            jobCategories: [] as any,
            jobCategorieToDelete: null as number | null,
            blogCategoryCounts: 0,
            blogCategories: [] as any,
            blogCategorieToDelete: null as number | null
        };
    },
    beforeRouteEnter(
        to: RouteLocationNormalized,
        from: RouteLocationNormalized,
        next: NavigationGuardNext
    ) {
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isLoggedIn !== "true") {
            next({ name: 'Login' });
        } else {
            next();
        }
    },
    computed: {
    },
    components: {
        adminHeader,
        adminNavigation
    },
    created() {
        this.fetchBanners();
        this.fetchArticles();
        this.fetchServices();
        this.fetchIndustries();
        this.fetchClients();
        this.fetchJobs();
        this.fetchBlogs();
        this.fetchContacts();
        this.fetchTeamMembersCount();
        this.fetchTeamMembers(1);
        this.fetchJoinOurTeam();
        this.fetchJoinOurTeamCounts();
        this.fetchJobCategoryCount();
        this.fetchJobCategory();
        this.fetchBlogCategoryCount();
        this.fetchBlogCategory();
    },
    methods: {
        async fetchBanners() {
            try {
                const baseUrl = `${API_BASE_URL}/banner/count/`;

                const [allResponse, publishedResponse, unpublishedResponse] = await Promise.all([
                    axios.get(`${baseUrl}?status=0&status=1`),
                    axios.get(`${baseUrl}?status=1`),
                    axios.get(`${baseUrl}?status=0`)
                ]);


                this.bannerCounts = {
                    all: allResponse.data.count,
                    published: publishedResponse.data.count,
                    unpublished: unpublishedResponse.data.count
                };

            } catch (error) {
                console.error('Error fetching banners:', error);
            }
        },
        async fetchArticles() {
            try {
                const baseUrl = `${API_BASE_URL}/article/count/`;

                const [allResponse, publishedResponse, unpublishedResponse] = await Promise.all([
                    axios.get(`${baseUrl}?status=0&status=1`),
                    axios.get(`${baseUrl}?status=1`),
                    axios.get(`${baseUrl}?status=0`)
                ]);


                this.articleCounts = {
                    all: allResponse.data.count,
                    published: publishedResponse.data.count,
                    unpublished: unpublishedResponse.data.count
                };
            }
            catch (error) {
                console.error('Error fetching articles:', error);
            }
        },
        async fetchServices() {
            try {
                const baseUrl = `${API_BASE_URL}/service/count/`;
                const [allResponse, publishedResponse, unpublishedResponse] = await Promise.all([
                    axios.get(`${baseUrl}?status=0&status=1`),
                    axios.get(`${baseUrl}?status=1`),
                    axios.get(`${baseUrl}?status=0`)
                ]);
                this.serviceCounts = {
                    all: allResponse.data.count,
                    published: publishedResponse.data.count,
                    unpublished: unpublishedResponse.data.count
                };
            } catch (error) {
                console.error('Error fetching services:', error);
            }
        },
        async fetchIndustries() {
            try {
                const baseUrl = `${API_BASE_URL}/industry/count/`;
                const [allResponse, publishedResponse, unpublishedResponse] = await Promise.all([
                    axios.get(`${baseUrl}?status=0&status=1`),
                    axios.get(`${baseUrl}?status=1`),
                    axios.get(`${baseUrl}?status=0`)
                ]);
                this.industryCounts = {
                    all: allResponse.data.count,
                    published: publishedResponse.data.count,
                    unpublished: unpublishedResponse.data.count
                };
            } catch (error) {
                console.error('Error fetching industries:', error);
            }
        },
        async fetchClients() {
            try {
                const baseUrl = `${API_BASE_URL}/client/count/`;
                const [allResponse, publishedResponse, unpublishedResponse] = await Promise.all([
                    axios.get(`${baseUrl}?status=0&status=1`),
                    axios.get(`${baseUrl}?status=1`),
                    axios.get(`${baseUrl}?status=0`)
                ]);
                this.clientCounts = {
                    all: allResponse.data.count,
                    published: publishedResponse.data.count,
                    unpublished: unpublishedResponse.data.count
                };
            } catch (error) {
                console.error('Error fetching clients:', error);
            }
        },
        async fetchJobs() {
            try {
                const baseUrl = `${API_BASE_URL}/job/count/`;
                const [allResponse, publishedResponse, unpublishedResponse] = await Promise.all([
                    axios.get(`${baseUrl}?status=0&status=1`),
                    axios.get(`${baseUrl}?status=1`),
                    axios.get(`${baseUrl}?status=0`)
                ]);
                this.jobCounts = {
                    all: allResponse.data.count,
                    published: publishedResponse.data.count,
                    unpublished: unpublishedResponse.data.count
                };
            } catch (error) {
                console.error('Error fetching jobs:', error);
            }
        },
        async fetchBlogs() {
            try {
                const baseUrl = `${API_BASE_URL}/blog/count/`;
                const [allResponse, publishedResponse, unpublishedResponse] = await Promise.all([
                    axios.get(`${baseUrl}?status=0&status=1`),
                    axios.get(`${baseUrl}?status=1`),
                    axios.get(`${baseUrl}?status=0`)
                ]);
                this.blogCounts = {
                    all: allResponse.data.count,
                    published: publishedResponse.data.count,
                    unpublished: unpublishedResponse.data.count
                };
            } catch (error) {
                console.error('Error fetching blogs:', error);
            }
        },
        async fetchContacts() {
            try {
                const baseUrl = `${API_BASE_URL}/contactus/count/`;
                const response = await axios.get(`${baseUrl}?status=1`);
                this.contactCounts = response.data.count
            } catch (error) {
                console.error('Error fetching contacts:', error);
            }
        },
        async fetchTeamMembersCount() {
            try {
                const baseUrl = `${API_BASE_URL}/teammember/count/`;
                const [allResponse, publishedResponse, unpublishedResponse] = await Promise.all([
                    axios.get(`${baseUrl}?status=0&status=1`),
                    axios.get(`${baseUrl}?status=1`),
                    axios.get(`${baseUrl}?status=0`)
                ]);
                this.teamMemberCounts = {
                    all: allResponse.data.count,
                    published: publishedResponse.data.count,
                    unpublished: unpublishedResponse.data.count
                };

            } catch (error) {
                console.error('Error fetching team members:', error);
            }
        },
        async fetchTeamMembers(status: number) {
            try {
                const response = await fetch(`${API_BASE_URL}/teammember/?status=${status}&limit=8`);
                const data = await response.json();
                this.teamMembers = data;
            } catch (error) {
                console.error('Error fetching team members:', error);
            }
        },
        setActiveTab(status: number) {
            this.teamMemberActiveTab = status;
            this.fetchTeamMembers(status);
        },
        async fetchJoinOurTeam() {
            try {
                const response = await fetch(`${API_BASE_URL}/candidates/?status=0&limit=5`);
                const data = await response.json();
                this.joinOurTeam = data;
            } catch (error) {
                console.error('Error fetching join our team:', error);
            }
        },

        async downloadResume(memberId: number, memberName: string) {
            try {
                const response = await axios.post(`${API_BASE_URL}/candidates/download-resumes/`, {
                    ids: [memberId]
                }, { responseType: 'blob' });
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = `${memberName}.pdf`;
                link.click();
            } catch (error) {
                console.error('Error fetching join our team:', error);
            }
        },
        async fetchJoinOurTeamCounts() {
            try {

                const baseUrl = `${API_BASE_URL}/candidates/count/`;
                const response = await axios.get(`${baseUrl}`);
                this.joinOurTeamCounts = response.data.count
            } catch (error) {
                console.error('Error fetching join our team counts:', error);
            }
        },
        async fetchJobCategoryCount(){
            try {
                const baseUrl = `${API_BASE_URL}/jobcategory/count/`;
                const response = await axios.get(`${baseUrl}`);
                this.jobCategoryCounts = response.data.count
            } catch (error) {
                console.error('Error fetching job category counts:', error);
            }
        },
        async fetchJobCategory(){
            try {
                const response = await fetch(`${API_BASE_URL}/jobcategory/?limit=4`);
                const data = await response.json();
                this.jobCategories = data;
            } catch (error) {
                console.error('Error fetching job categories:', error);
            }
        },
        async changeJobCategorieStatus(jobCategorieId: number, newStatus: number) {
            try {
                const formData = new FormData();
                formData.append('status', newStatus.toString());

                await axios.patch(`${API_BASE_URL}/jobcategory/${jobCategorieId}/`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                this.fetchJobCategory()
            } catch (error) {
                console.error('Error updating jobCategorie status:', error);
            }
        },
        setDeleteMode(jobCategorieId?: number) {
            if (jobCategorieId !== undefined) {
                this.jobCategorieToDelete = jobCategorieId;
            }
        },
        async deleteJobCategorie() {
            try {
                await axios.delete(`${API_BASE_URL}/jobcategory/${this.jobCategorieToDelete}/`);
                this.fetchJobCategory();
                this.fetchJobCategoryCount();
                (this.$refs.dummyButton as HTMLElement).click();
            } catch (error) {
                console.error('Error deleting jobCategorie:', error);
            }
        },
        goToEditPage(id:number, index:number) {
        this.$router.push({
            path: '/authority/job-category',
            query: { 
                id, 
                index,  
            }
        });
    },
    async fetchBlogCategoryCount(){
            try {
                const baseUrl = `${API_BASE_URL}/blogcategory/count/`;
                const response = await axios.get(`${baseUrl}`);
                this.blogCategoryCounts = response.data.count
            } catch (error) {
                console.error('Error fetching blog category counts:', error);
            }
        },
        async fetchBlogCategory(){
            try {
                const response = await fetch(`${API_BASE_URL}/blogcategory/?limit=4`);
                const data = await response.json();
                this.blogCategories = data;
            } catch (error) {
                console.error('Error fetching Blog categories:', error);
            }
        },
        async changeBlogCategorieStatus(blogCategorieId: number, newStatus: number) {
            try {
                const formData = new FormData();
                formData.append('status', newStatus.toString());

                await axios.patch(`${API_BASE_URL}/blogcategory/${blogCategorieId}/`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                this.fetchBlogCategory();
            } catch (error) {
                console.error('Error updating blogCategorie status:', error);
            }
        },
        setBlogDeleteMode(blogCategorieId?: number) {
            if (blogCategorieId !== undefined) {
                this.blogCategorieToDelete = blogCategorieId;
            }
        },
        async deleteBlogcategorie() {
            try {
                await axios.delete(`${API_BASE_URL}/blogcategory/${this.blogCategorieToDelete}/`);
                this.fetchBlogCategory();
                this.fetchBlogCategoryCount();
                (this.$refs.dummyButton as HTMLElement).click();
            } catch (error) {
                console.error('Error deleting jobCategorie:', error);
            }
        },
        goToBlogEditPage(id:number, index:number) {
        this.$router.push({
            path: '/authority/blog-category',
            query: { 
                id, 
                index,  
            }
        });
    }, 
    getCdnImageAddress(src: string, size: string): string {
        if (!src) return '';
        let cdnUrl: string = environment.imageCdn.getHost;
        cdnUrl = cdnUrl.concat(size);
        return cdnUrl + encodeURIComponent(src);
    },

    deleteCategorie() {
        if (this.jobCategorieToDelete) {
            this.deleteJobCategorie();
        } else if (this.blogCategorieToDelete) {
            this.deleteBlogcategorie();
        }
    },

    toggleStatus(id: number, status: number, type: 'blog-category' | 'job-category') {
        const newStatus = status === 0 ? 1 : 0;
        
        if(type === 'blog-category'){
            this.changeBlogCategorieStatus(id, newStatus);
        }
        else if(type === 'job-category'){
            this.changeJobCategorieStatus(id, newStatus);
        }
    },

    }
});
</script>